import { takeEvery, call, put } from "redux-saga/effects";
import {
  GET_PUBLICATION_SCHEDULE_REQUEST,
  getPublicationScheduleSuccess,
  getPublicationScheduleFailure,
} from "../actions/publicationScheduleActions";
import { fetchPublicationScheduleFromApi } from "../apis/publicationScheduleApi";

function* getPublicationScheduleSaga(action) {
  try {
    const data = yield call(fetchPublicationScheduleFromApi, action.payload);
    yield put(getPublicationScheduleSuccess(data));
  } catch (error) {
    console.error("publicationScheduleSaga - Error fetching schedule:", error);
    const raw = error?.message || "";
    // Provide a clean message when the BE query is not yet deployed
    const isNotDeployed =
      raw.includes("FieldUndefined") ||
      raw.includes("is undefined") ||
      raw.includes("UnknownType");
    const message = isNotDeployed
      ? "Publication schedule endpoint is not yet available. Please check back once the backend update has been deployed."
      : raw || "Failed to load publication schedule";
    yield put(getPublicationScheduleFailure(message));
  }
}

function* watchPublicationScheduleActions() {
  yield takeEvery(GET_PUBLICATION_SCHEDULE_REQUEST, getPublicationScheduleSaga);
}

export default watchPublicationScheduleActions;
